export default {
    onShareAppMessage () {
        return this.getShareInfo({
            title: '房贷计算器',
            path: '/pages/loan_computer/main',
            imageUrl: 'https://cdn.vip-wifi.com/njxfy/img/share/loan-computer.png'
        }, 'LOAN_COMPUTER')
    }
}